/**
 * Config del eje X compartida por todas las gráficas de histórico (línea de
 * tiempo por fecha). Centralizado para no repetir la misma lógica de
 * densidad/rotación en cada sección.
 */
export function buildDateCategoryAxis(categories: string[]) {
  // Con un rango de 30 días, mostrar las 30 fechas satura el eje y las deja
  // ilegibles (motivo original del reporte). tickAmount limita cuántas
  // etiquetas se dibujan -- ApexCharts reparte el resto uniformemente sobre
  // el rango -- y rotate les da espacio diagonal para no solaparse entre sí.
  const tickAmount = categories.length > 12 ? 10 : undefined;

  return {
    categories,
    tickAmount,
    labels: {
      style: { fontSize: '11px' },
      rotate: -45,
      rotateAlways: categories.length > 8,
      hideOverlappingLabels: true,
    },
  };
}
